// Z-index constants for consistent layering across the application
export const Z_INDEX = {
  // Background layers
  BACKGROUND: 0,
  
  // Base UI elements
  BASE: 10,
  
  // Navigation and headers
  HEADER: 20,
  NAVIGATION: 30,
  
  // Status indicators and notifications
  STATUS_INDICATOR: 40,
  
  // Mobile navigation
  MOBILE_NAVIGATION: 50,
  
  // Modals and overlays
  MODAL_OVERLAY: 60,
  MODAL: 70,
  
  // PWA components (highest priority)
  PWA_INSTALL_PROMPT: 80,
  PWA_NETWORK_STATUS: 90,
  
  // Tooltips and popovers
  TOOLTIP: 100,
  POPOVER: 110,
  
  // Toast notifications
  TOAST: 120,
  
  // Loading spinners
  LOADING: 130,
  
  // Development tools
  DEV_TOOLS: 1000
} as const;

// Helper function to get z-index value
export const getZIndex = (key: keyof typeof Z_INDEX): number => {
  return Z_INDEX[key];
};

// Helper function to create CSS-in-JS style object with z-index
export const zIndexStyle = (key: keyof typeof Z_INDEX) => ({
  zIndex: Z_INDEX[key]
});